const capitalize = (str) => {
  if (!str?.length) return null;
  return str.slice(0, 1).toUpperCase().concat(str.slice(1));
};

export default capitalize;
